// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"4f25f4b3","164":"76d2d65b","254":"ccc8410d","301":"83de9caf","444":"a106f215","453":"4bb6afec","721":"3320bdff"}[chunkId] + ".chunk.js";
};